module.exports = __webpack_public_path__ + "img/potion_17.161c2753.png";